import { Route, Routes } from 'react-router-dom';
import UnderMaintenanceComponent from './error/under-maintenance';

export const PublicAuthenticatedRoutes = () => {
  return (
    <Routes>
      <Route path='under_maintenance' element={<UnderMaintenanceComponent />} />
    </Routes>
  );
};
